/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface IOperatorPopupScope extends angular.IScope {

        // Use this for the popover at the top level
        calculation: Wars.Domain.Model.Calculations.Calculation;

        // Use these for the popover at the operand level
        operation: Wars.Domain.Model.Calculations.ValueOperation;
        operandIndex: number;

        initialized: boolean;
        allowDelete: boolean;
        defaultOpen: string;

        templateUrl: string;
        isOpen: boolean;
        open(): void;
        close(): void;
        operatorSelected(operator: Wars.Domain.Model.Codes.Enums.ValueOperator): void;
        showChangeConfirmation: boolean;
        change: () => void;
        cancel: () => void;
        clear: () => void;
        delete: () => void;
        showNumericOperators: boolean;
        showStringOperators: boolean;
        showDateTimeOperators: boolean;
        showBooleanOperators: boolean;
        showAggregateOperators: boolean;
        showListOperators: boolean;
        showOtherOperators: boolean;
        showNumericOperatorsSelected : () => void;
        showStringOperatorsSelected : () => void;
        showBooleanOperatorsSelected : () => void;
        showAggregateOperatorsSelected : () => void;
        showOtherOperatorsSelected: () => void;
        showDateTimeOperatorsSelected: () => void;
        showListOperatorsSelected: () => void;
        allowNumericOperator: boolean;
        allowStringOperator: boolean;
        allowDateTimeOperator: boolean;
        allowBooleanOperator: boolean;
        allowAggregateOperators: () => boolean;
        allowListOperators: () => boolean;
        allowOtherOperator: boolean;
        operatorTypesAllowed: models.CalculationType[];
    }

    export class OperatorPopup implements IDirective {
        public controller = ['$scope', 'calculationService', OperatorPopupController];
        public controllerAs = 'controller';
        public templateUrl = './app/views/directives/calculate/operatorPopup.html';
        public restrict: string = "E";

        public scope: any = {
            calculation: "=",
            operation: "=",
            operandIndex: "=",
            initialized: "=",
            defaultOpen: "=",
            operatorTypesAllowed: "=",
            faClass: "@",
            buttonClass: "@"
        };

        public link(scope: IOperatorPopupScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, controller: OperatorPopupController): void {
            scope.templateUrl = "./app/views/directives/calculate/operatorPopupContent.html";
        }
    }

    export class OperatorPopupController implements IController {
        
        operatorSelectedValue: Wars.Domain.Model.Codes.Enums.ValueOperator;

        constructor(private $scope: IOperatorPopupScope, private calculationService: services.CalculationService) {
            this.$scope.isOpen = this.$scope.defaultOpen === "true";
            this.$scope.showChangeConfirmation = false;

            var self = this;
            this.$scope.$watch("defaultOpen", (newValue) => {
                if (newValue) self.openInternal();
                else self.closeInternal();
            });

            this.$scope.allowDelete = this.calculationService.allowOperandDelete(this.$scope.operation, this.$scope.operandIndex);

            // Public methods using lambdas to preserve this
            this.$scope.open = () => this.openInternal();
            this.$scope.close = () => this.closeInternal();
            this.$scope.operatorSelected = (operator: Wars.Domain.Model.Codes.Enums.ValueOperator) => this.operatorSelectedInternal(operator);
            this.$scope.change = () => this.changeOperand();
            this.$scope.cancel = () => this.$scope.isOpen = false;
            this.$scope.clear = () => this.clearInternal();
            this.$scope.delete = () => this.deleteInternal();

            this.$scope.allowNumericOperator = this.allowNumericOperatorInternal();
            this.$scope.allowStringOperator = this.allowStringOperatorInternal();
            this.$scope.allowDateTimeOperator = this.allowDateTimeOperatorInternal();
            this.$scope.allowBooleanOperator = this.allowBooleanOperatorInternal();
            this.$scope.allowAggregateOperators = () => this.allowAggregateOperatorsInternal();
            this.$scope.allowListOperators = () => this.allowListOperatorsInternal();
            this.$scope.allowOtherOperator = this.allowOtherOperatorInternal();

            this.$scope.showNumericOperatorsSelected = () => {
                this.hideAll();
                this.$scope.showNumericOperators = true;
            }

            this.$scope.showStringOperatorsSelected = () => {
                this.hideAll();
                this.$scope.showStringOperators = true;
            }

            this.$scope.showDateTimeOperatorsSelected = () => {
                this.hideAll();
                this.$scope.showDateTimeOperators = true;
            }

            this.$scope.showBooleanOperatorsSelected = () => {
                this.hideAll();
                this.$scope.showBooleanOperators = true;
            }

            this.$scope.showAggregateOperatorsSelected = () => {
                this.hideAll();
                this.$scope.showAggregateOperators = true;
            }

            this.$scope.showOtherOperatorsSelected = () => {
                this.hideAll();
                this.$scope.showOtherOperators = true;
            }

            this.$scope.showListOperatorsSelected = () => {
                this.hideAll();
                this.$scope.showListOperators = true;
            }
        }

        private allowNumericOperatorInternal(): boolean {
            if (this.$scope.operatorTypesAllowed === undefined) return true;
            return this.$scope.operatorTypesAllowed.indexOf(models.CalculationType.Numeric) !== -1;
        }

        private allowStringOperatorInternal(): boolean {
            if (this.$scope.operatorTypesAllowed === undefined) return true;
            return this.$scope.operatorTypesAllowed.indexOf(models.CalculationType.String) !== -1;
        }

        private allowDateTimeOperatorInternal(): boolean {
            if (this.$scope.operatorTypesAllowed === undefined) return true;
            return this.$scope.operatorTypesAllowed.indexOf(models.CalculationType.DateTime) !== -1;
        }

        private allowBooleanOperatorInternal(): boolean {
            if (this.$scope.operatorTypesAllowed === undefined) return true;
            return this.$scope.operatorTypesAllowed.indexOf(models.CalculationType.Boolean) !== -1;
        }

        private allowAggregateOperatorsInternal(): boolean {
            if (this.$scope.operatorTypesAllowed !== undefined && this.$scope.operatorTypesAllowed.indexOf(models.CalculationType.Other) === -1) return false;
            if (this.$scope.calculation) return this.calculationService.allowAggregateOperators(this.$scope.calculation.valueOperation);
            return this.calculationService.allowAggregateOperatorsForOperand(this.$scope.operation, this.$scope.operation.operands[this.$scope.operandIndex]);
        }

        private allowListOperatorsInternal(): boolean {
            if (this.$scope.operatorTypesAllowed !== undefined && this.$scope.operatorTypesAllowed.indexOf(models.CalculationType.Other) === -1) return false;
            if (this.$scope.calculation) return this.calculationService.allowAggregateOperators(this.$scope.calculation.valueOperation);
            return this.calculationService.allowAggregateOperatorsForOperand(this.$scope.operation, this.$scope.operation.operands[this.$scope.operandIndex]);
        }

        private allowOtherOperatorInternal(): boolean {
            if (this.$scope.operatorTypesAllowed !== undefined && this.$scope.operatorTypesAllowed.indexOf(models.CalculationType.Other) === -1) return false;
            if (this.$scope.calculation) return this.calculationService.allowListOperators(this.$scope.calculation.valueOperation);
            return this.calculationService.allowListOperatorsForOperand(this.$scope.operation, this.$scope.operation.operands[this.$scope.operandIndex]);
        }

        private openInternal(): void {
            this.$scope.isOpen = true;
        }

        private closeInternal(): void {
            this.$scope.isOpen = false;
        }

        private operatorSelectedInternal(operator: Wars.Domain.Model.Codes.Enums.ValueOperator) {
            this.operatorSelectedValue = operator;
            if (this.$scope.calculation) {
                this.changeTopLevelValueOperation();
            } else {
                if (this.$scope.initialized) {
                    this.$scope.showChangeConfirmation = true;
                } else {
                    this.changeOperand();
                }
            }
        }

        private clearInternal() {
            this.calculationService.replaceOperandWithNewSimpleOperand(this.$scope.operation, this.$scope.operandIndex);
            this.$scope.isOpen = false;
        }

        private deleteInternal() {
            this.$scope.operation.operands[this.$scope.operandIndex].entityAspect.setDeleted();
            this.$scope.isOpen = false;
        }

        private changeOperand(): void {
            if (this.operatorSelectedValue !== undefined) {
                this.calculationService.replaceOperandWithNewComplexOperand(this.$scope.operation, this.$scope.operandIndex, this.operatorSelectedValue);
            }
            this.$scope.isOpen = false;
        }

        private changeTopLevelValueOperation(): void {
            if (this.$scope.calculation.valueOperation == undefined) {
                var isListOperation = this.calculationService.isAnAggregateOperator(this.operatorSelectedValue) ||
                    this.calculationService.isAListOperator(this.operatorSelectedValue);
                this.$scope.calculation.valueOperation = this.calculationService.createValueOperation(this.operatorSelectedValue, isListOperation);
                this.$scope.calculation.valueOperation_id = this.$scope.calculation.valueOperation.id;
            }
            else {
                this.$scope.calculation.valueOperation = this.calculationService.createNewTopLevelValueOperation(this.$scope.calculation.valueOperation, this.operatorSelectedValue);
                this.$scope.calculation.valueOperation_id = this.$scope.calculation.valueOperation.id;
            }
            this.$scope.calculation.valueOperation.variableType = services.CalculationService.getValueOperationVariableType(this.$scope.calculation.valueOperation);
            this.$scope.isOpen = false;
        }

        private hideAll(): void {
            this.$scope.showNumericOperators = false;
            this.$scope.showStringOperators = false;
            this.$scope.showDateTimeOperators = false;
            this.$scope.showBooleanOperators = false;
            this.$scope.showAggregateOperators = false;
            this.$scope.showListOperators = false;
            this.$scope.showOtherOperators = false;
        }
    }
}

warsApp.registerDirective('OperatorPopup', []);